/*
 *
 * Return liquid filters for the achievementType logics
 * This liquid expression is applied and the result of the logic.graphQlQuery to check if achievement has to be unlocked
 *
 * Each liquid expression has to start with "data"
 * Each liquid expression has to print "True" if the achievement is supposed to be unlocked
 *
 * e.g : {%- if data.internals.list[0].courseProgressions[0].isPassed -%} True {%- endif -%}
 *
 * To input arguments inside the template, the 'id' field in the 'args' has to be the same as the name of the variables in the 'get' function
 *
 */

const liquidConditionsTemplates = [
	{
		id: "course_is_passed",
		args: [],
		build: () => {
			return `{%- if data.internals.list[0].courseProgressions[0].isPassed -%} True {%- endif -%}`
		}
	},
	{
		id: "number_of_courses_passed",
		args: [
			{
				id: "numberOfCourses",
				localeKey: "number_of_courses",
				component: "j-base-input-number"
			}
		],
		build: ({ numberOfCourses }) => {
			return `
{%- assign numberOfCoursesPassed = 0 -%}
{%- for courseProgression in data.internals.list[0].courseProgressions -%}
	{%- if courseProgression.isPassed -%}
		{%- assign numberOfCoursesPassed = numberOfCoursesPassed | plus: 1 -%}
    {%- endif -%}
{%- endfor -%}
{%- if numberOfCoursesPassed >= ${numberOfCourses} -%}
    True
{%- endif -%}`
		}
	}
]

export default liquidConditionsTemplates
